import React, { Suspense } from 'react';
import Header from './Header';
import Footer from './Footer';
import CookieBanner from './CookieBanner';
import ScrollToTop from './ScrollToTop';
import Seo from './Seo';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col font-sans selection:bg-maat-gold/30 selection:text-maat-blue">
            <Seo />
            <ScrollToTop />
            <Header />
            <CookieBanner />
            <main className="flex-grow">
                <Suspense fallback={
                    <div className="min-h-screen flex items-center justify-center bg-maat-stone">
                        <div className="w-12 h-12 border-4 border-maat-gold border-t-transparent rounded-full animate-spin"></div>
                    </div>
                }>
                    {children}
                </Suspense>
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
